<template>
<div class="my-listings">
    <a href="#" class="my-traders-link" data-bs-toggle="modal" data-bs-target="#list-my-traders"><slot></slot></a>
    <div class="modal fade" id="list-my-traders" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">List Pins<span v-if="limit > -1"> - <strong>{{ limitNumber }} Left</strong></span></h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">

                    <template v-if="traders.length">
                        <div v-if="unlistedTraders.length" class="alert alert-trader" role="alert">
                            <h3 class="alert-heading">List Your Traders:</h3>
                            <p>Select the pins you'd like to list on this virtual table and receive trade offers from other traders. Even though you list them, you can still use them to make trade offers on other pins listed here.</p>
                            <h5>Good Luck and Happy Trading!</h5>
                        </div>
                        <div v-else class="alert alert-success" role="alert">
                            <h3 class="alert-heading">All Traders Listed:</h3>
                            <p>You've already listed all of your traders eligible for this table.</p>
                            <h5>Good Luck and Happy Trading!</h5>
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="loadingTraders" class="alert alert-trader" role="alert">
                            <h3 class="alert-heading">Loading Your Traders:</h3>
                            <p>If you have a lot of traders this could be a minute...</p>
                        </div>
                        <div v-else class="alert alert-warning" role="alert">
                            <h3 class="alert-heading">No Eligible Traders Found:</h3>
                            <p>If you have <a href="/my/collection/traders" target="_blank">traders</a> in your account that are not displaying here, it's likely because this table only allows pins from specific series to be traded.</p>
                        </div>
                    </template>

                    <template v-if="traders.length && unlistedTraders.length">
                        <TradersBoard
                            :user="0"
                            :traders="unlistedTraders"
                            :limit="limitNumber"
                            @toggle="toggleTraderPin"
                        ></TradersBoard>
                    </template>

                </div>

                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-link text-secondary me-4" data-bs-dismiss="modal">Close</button>
                    <button v-if="unlistedTraders.length" @click="addToBoard" type="button" class="btn btn-lg btn-trader text-light" id="init-list" data-bs-dismiss="modal"><i class="fa-solid fa-plus-circle"></i> List On Table</button>
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import TradersBoard from "./TradersBoard.vue";

export default {
    name: "MyListings",
    components: {
        TradersBoard
    },
    props: {
        boardId: {
            type: Number,
            required: false
        },
        myListings: {
            type: Array,
            required: false
        },
        limit: {
            type: Number,
            default: -1
        },
        udlist: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            traders: [],
            loadingTraders: true
        }
    },
    computed: {
        unlistedTraders: function() {
            // return this.traders.filter(t => !this.myListings.find(l => l.pinventory_id === t.id));
            return this.traders;
        },

        limitNumber: function() {
            if (this.limit < 0) {
                return this.limit;
            } else {
                let selected = this.traders.filter(t => t.selected).length;
                return this.limit - selected;
            }
        }
    },
    methods: {
        // getUnlistedTraders: function() {
        //     this.unlistedTraders = this.traders.filter(t => !this.myListings.find(l => l.pinventory_id === t.id));
        // },

        toggleTraderPin(traderId, toggle = null) {
            let index = this.traders.findIndex(x => x.id === traderId);
            if (this.limitNumber !== 0 || this.traders[index].selected) {
                if (this.traders[index].is_listed && !this.udlist) {
                    return false;
                }
                this.traders[index].selected = toggle !== null ? toggle : !this.traders[index].selected;
            }
        },

        addToBoard() {
            let traders = this.unlistedTraders.filter(trader => trader.selected);
            axios.post('/pin-trading/listings', {
                board: this.boardId,
                // pinventory: traders.map(t => t.id),
                collection: traders.map(t => t.id),
                mode: 'lister'
            }).then(response => {
                let listings = response.data.add;
                let remove = response.data.remove;

                listings.forEach(listing => {
                    // let trader = traders.find(t => t.id === listing.pinventory_id);
                    let trader = traders.find(t => t.id === listing.collection_id);
                    trader.is_listed = true;

                    listing.code = trader.code;
                    listing.edition = trader.edition;
                    listing.edition_code = trader.edition;
                    listing.image_name = trader.image_name;
                    listing.image_path = trader.image_path;
                    listing.image_pinail = trader.image_pinail;
                    listing.isGrail = false;
                    listing.isIso = false;
                    listing.edition_size = 0;
                    listing.name = trader.name;
                    listing.offers_count = 0;
                    listing.origin_id = trader.origin_id;
                    listing.original_price = null;
                    listing.pendingOffer = null;
                    listing.pin_id = trader.pin_id;
                    // listing.pinventory_id = trader.id;
                    listing.collection_id = trader.id;
                    listing.released_at = null;
                    listing.series = trader.series;
                    listing.series_id = trader.series_id;
                    listing.series_slug = null;
                    listing.series_url = null;
                    listing.tags = [];
                    listing.title = trader.title;
                    listing.url = null;
                });

                this.$emit('addToListings', listings);
                this.$emit('removeFromListings', remove);
            });
        }
    },
    mounted() {
        document.getElementById('list-my-traders').addEventListener('hidden.bs.modal', () => {
            // this.traders.forEach((trader) => trader.selected = false);
        });
    },
    created() {
        
        VueEvent.$on('loadedTraders', (traders) => {
            this.loadingTraders = false;
            traders = JSON.parse(JSON.stringify(traders));
            // let selected = traders.filter(t => this.myListings.find(l => l.pinventory_id === t.id));
            let selected = traders.filter(t => this.myListings.find(l => l.collection_id === t.id));
            selected.forEach(t => t.selected = true);
            this.traders = traders.sort((a, b) => a.selected ? -1 : 1);
        });
    }
}
</script>
